import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Col, Row, Alert } from 'react-bootstrap';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { classNames } from 'primereact/utils';
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../../hooks/useAuth';
import logo from '../../../assets/images/logo-horizontal-white.png';
import video from '../../../assets/videos/sign-in-headline/sign-in-headline.mp4';
import * as PROFILE from "../../../constants/profile";
import './SignIn.scss';

function SignIn() {
  const { login } = useAuth();
  const [alertWarningIsVisible, setAlertWarningIsVisible] = useState(false);
  const navigate = useNavigate();
  const defaultValues = {
    username: '',    
    password: ''    
  }

  const { control, formState: { errors }, handleSubmit, reset } = useForm({ defaultValues });
  
  const onSubmit = (data) => {
    resetAlerts();
    signIn(data.username, data.password);
  };

  const signIn = (
    username,
    pass) => {
    fetch(`${process.env.REACT_APP_API_URL}/airportService/v1/user/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username,
        pass
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        if (data.responseObject.userId === 0) {
          console.log("Error", data);          
          setAlertWarningIsVisible(true);
        } else {
          const user = data.responseObject;
          const pages = user.pages;
          const hasDriverAssigmentPage = pages.filter(page => page === PROFILE.PERMISSIONS.ASSIGNMENT_BY_DRIVER).length > 0;          
          login(user);
          if (hasDriverAssigmentPage) {
            navigate("driverAssignment");
          } else {
            navigate("home");
          }          
          reset();
        }        
      } 
    });
  }

  const resetAlerts = () => {
    setAlertWarningIsVisible(false);
  };


  const getFormErrorMessage = (name) => {
    return errors[name] && <small className="app-poppins-extra-light-font p-error">{errors[name].message}</small>
  };

  const reportTemplate = (
    <>      
      <article className='app-sign-in'>
        <video className='app-sign-in-video-bg' autoPlay muted loop>
          <source src={video} type="video/mp4" />
            Your browser does not support HTML5 video.
        </video>
        <Row className='p-4'>          
          <Col xs={12} md={{ offset: 3, span: 6 }}>
            <Row>
              <Col>
                <img
                  src={logo}
                  height="70"
                  className="d-inline-block align-top mt-5 mb-5"
                  alt="Ecofy logo"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <h1 className='app-neutral-white-text app-poppins-bold-font text-uppercase'>
                  Inicio de sesión
                </h1>
              </Col>
            </Row>
            <Row>
              <Col>
                <Alert
                  key='warning'
                  variant='warning'
                  hidden={!alertWarningIsVisible}>
                  El usuario no existe
                </Alert>
              </Col>
            </Row>
            <Row>
              <Col>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
                  <Row className='pt-2'>
                    <Col>
                      <label 
                        htmlFor="username" 
                        className={`app-neutral-white-text app-poppins-regular-font ${classNames({ 'p-error': errors.username }) }`}>
                        Usuario*
                      </label>
                      <Controller name="username" control={control} rules={{ required: 'El usuario es requerido.' }} render={({ field, fieldState }) => (
                        <InputText id={field.username} {...field} autoFocus className={classNames({ 'p-invalid': fieldState.invalid })} />
                      )} />
                      {getFormErrorMessage('username')}
                    </Col>
                  </Row>
                  <Row className='pt-2'>
                    <Col>
                      <label 
                        htmlFor="password"
                        className={`app-neutral-white-text app-poppins-regular-font ${classNames({ 'p-error': errors.password })}`}>
                        Contraseña*
                      </label>
                      <Controller name="password" control={control} rules={{ required: 'La contraseña es requerida.' }} render={({ field, fieldState }) => (
                        <Password id={field.name} {...field} toggleMask className={classNames({ 'p-invalid': fieldState.invalid })} feedback={false} />
                      )} />
                      {getFormErrorMessage('password')}
                    </Col>
                  </Row>
                  <Button type="submit" label="Iniciar sesión" className="app-poppins-regular-font mt-4" />
                </form>
              </Col>
            </Row>
          </Col>
        </Row>
      </article>      
    </>
  );

  return (
    <>
      {reportTemplate}
    </>
  );
}

export default SignIn;